module.exports = __webpack_public_path__ + "static/8236a938913ca43fc51a75ad871be656.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/landing.mp4
// module id = 1189
// module chunks = 0